import { createBox } from '@dessert-box/react';
import React from 'react';
import { atoms } from './atoms.css';

export const Box = createBox({ atoms });

export type BoxProps = React.ComponentProps<typeof Box>;

export default Box;
